import {getElFormValidateValue, getLocalId} from "@/assets/js/utils";
import {isArray} from "my-tools-kit";
export let mixinsProductQuotation = {
  methods: {
    /**
     * 子页面表单验证
     */
    validatePageForm(formName = 'editForm') {
      return new Promise((resolve, reject) => {
        let form = this.$refs[formName];
        this.$refs[formName].validate((valid) => {
          let results = getElFormValidateValue(form);
          if (!valid) {
            return reject(results);
          }
          this.$message.success('提交表单');
          resolve(true)
        });
      });
    },
  }
};

/**
 * 将对象中指定的属性提取出来，返回新的对象
 */
export function extractSpecifiedAttribute(target={},keyName=[]) {
  let obj = {};
  keyName.forEach(key=>obj[key] = target[key]);
  return obj;
}

/**
 * 基础数据：获取物流产品基本信息
 */
export function baseDataLogisticsProductsDetails(){
  return {
    "isSupportPrivateAddress": false,//是否能走私人地址
    "scale": "-1", // -1:不进位 1：个位取整 2:0.1取整 3:0.5取整
    "cbmScale": "-1", //
    "cityList": [ // 可收货城市列表
      // {"cityname": "", "cityid": "",}
    ],
    "pieceWeightBiggestNotLimit": false, // 是否不约束低于单件最大计费重不能下单
    "tableHeadList": [ //分区配置区间值列表
      // {"chargeSectionDetailId": "", "chargeSectionTableHead": "",},
    ],
    "deliveryRegionHeaderList":[],// 派送分区价格信息列表
    "cityId": "",// 可收货城市id
    "podId": "", // 目的国家id
    "regionType": "", //分区类型
    "remark": "", // 备注
    "polnamec": null, // 起运地
    "agingUnit": 1, // 整体时效单位 1：工作日 2：自然日
    "transportNamec": "",// 运输方式
    "transportType": "",// 运输方式 LY：陆运 HY：海运 KY：空运
    "isNeedVat": false, // 是否需要VAT信息
    "orderWeightMinimum": "", // 单票最小计费重
    "podnamec": "", // 目的国家中文名
    "chargeCoefficient": null, // 计费系数
    "id": "", // 物流产品ID
    "pointsBubbleWay": '', // 分泡方式 1:实重；2：实重和体积重取大 3：分50%泡 4：分1/3泡 5：分30%泡 6：体积（CBM）
    "minimumCbm": null, // 最低体积
    "isSupportGeneralTrade": false, // 是否接一般贸易
    "specialRequirements": "",// 特殊要求
    "name": "", // 产品名称
    "goodsTypeNamec": null, // 可走货物类型
    "pieceWeightMinimumNotLimit": false, // 是否不约束低于单件最小计费重不能下单
    "chargeSectionHeaderId": "",//分区区间ID
    "extractionAgingTo": "", // 提取时效最长时间
    "pieceWeightBiggest": "", // 单件最大计费重
    "chargeType": "", // 计费方式
    "volumeWeightRatio": "", // 体积重比率
    "weightVolumeRatio": "",// 重量转换比例
    "packagingRequirements": "", // 包装要求
    "pieceWeightMinimum": "", // 单件最小计费重
    "containsTheTariffs": false, // 是否包含关税
    "code": "", // 产品代码
    "orderInformation": "", // 下单须知
    "agingTo": "", // 整体时效最长时间
    "orderWeightMinimumNotLimit": false,//是否不约束低于单票最小计费重不能下单
    "agingFrom": "", // 整体时效最短时间
    "warmPrompt": "", // 温馨提示
    "extractionAgingUnit": 1, // 提取时效单位 1：工作日 2：自然日
    "sailingTime": "", // 出航时间
    "minimumWeight": null, // 最低重量
    "extractionAgingFrom": "", // 提取时效最端时间
    "deliveryType": "", // 派送方式
    "overseasWarehouseId": null, // 海外仓id
  }
}

/**
 * 基础数据：产品报价数据结构(新增：提交表单)
 */
export function baseDataProductQuotation(){
  return {
    // 分区区间主id
    chargeSectionHeaderId: "",
    //计费单位
    chargeType:"",
    // 可收货城市(起运城市)[{id,cityName}]
    polCityList: [],
    // 可走货物类型[{id,goodsTypeName}]
    goodsTypeList: [],
    // 生效时间
    effectiveStartTime: "",
    // 失效时间
    effectiveEndTime: "",
    // 报价id (新增时为空)
    id: "",
    // 复制时，复制目标报价id
    copyFromId: "",
    // 标签1
    label1: "",
    // 标签2
    label2: "",
    // 标签3
    label3: "",
    // 物流产品id
    logisticsProductId: "",
    // 运力商产品id
    logisticsProductCarrierId: "",
    // 下单须知
    orderInformation: "",
    // 包装要求
    packagingRequirements: "",
    // 目的国家id
    podId: "",
    // 分泡方式
    pointsBubbleWay: "",
    // 起运地id
    polId: "",
    // 头程/默认 分区价格信息列表
    regionHeaderList: [
      // baseDataRegionHeaderItem(),
    ],
    // 派送分区价格信息列表
    deliveryRegionHeaderList:[],
    // 分区类型 1：邮编 2：国家 3：城市 4：仓库编码 5:邮编分区
    regionType: "",
    // 出航时间
    sailingTime: "",
    // 特殊要求
    specialRequirements: "",
    //状态 1：草稿 2：启用 3：作废
    state:'',
    // 体积重比率
    volumeWeightRatio: "",
    // 重量转换比例
    weightVolumeRatio: "",
    // 温馨提示
    warmPrompt: "",
    // 加收产品附加费
    isProductSurcharge: false,
    // 增值服务( 提价接口用)
    quoteAttachPrice:{},
    // 增值服务（本地编辑用）
    addedServiceList:baseDataAddedServiceList(),
    // 是否支持自提 1: 可自提 2：不可自提 3：强制自提
    selfDelivery:2,
    // 是否多渠道
    isSupportMultiChannel:false,
    // 非多渠道时的专线api对接渠道代码（仅供本地js结构，编辑展示使用，提交时需要填充至分区及价格明细列表中）
    channelCode:"",
    // 赔付标准
    compensationStandards: "",
    // 引用报价供应商Id
    smartCarrierId: "",
    // 船期信息 整柜直送时需要
    shippingDateInformation: "",
    // 派送方式
    deliveryType: "",
    // 海外仓
    overseasWarehouseId: "",
    // 专线渠道代码(物流产品代码)
    carrierProductCode: "",
    // 是否推送更新至收藏客户
    pushOpen:false,
    // 推送更新说明（true时必填）
    pushContent:"",
    // 币种（全包/分段头程）（仅供本地js结构，编辑展示使用，提交时需要填充至分区及价格明细列表中）
    currencyHead:"",
    // 币种（分段派送）（仅供本地js结构，编辑展示使用，提交时需要填充至分区及价格明细列表中）
    currencyDelivery:"",
    //货物入仓测量方式	1.机器量方 2.皮尺量方
    goodsMeasurementMethod:"",
    //是否支持线下议价: true 是 false 否，默认false
    whetherSupportedBargaining:false,
    //是否支持时效赔付: true 是 false 否，默认false
    whetherSupportedCompensate:false,
    // 是否支持货损赔付: true 是 false 否，无默认
    whetherSupportCompensation: true,
    // 船公司
    shippingCompanyList: [],
    // 是否准时达
    whetherGuaranteedDelivery: false,
    // 海运尾端派送类型
    endDeliveryTypeIds: [],
    // 截仓时间
    closeWarehouseTime: "",
    // 起运时间
    startShipmentTime: "",
    // 时效赔付标准
    supportedCompensateDesc: "",
    // 丢货赔付标准
    supportCompensationDesc: ""
  }
}

/**
 * 保存时需要的key name
 * @type {string[]}
 */
export let saveNeedParamsKeyArray = [
  "chargeSectionHeaderId",
  "chargeType",
  "polCityList",
  "effectiveEndTime",
  "effectiveStartTime",
  "id",
  "copyFromId",
  "label1",
  "label2",
  "label3",
  "logisticsProductId",
  "logisticsProductCarrierId",
  "orderInformation",
  "packagingRequirements",
  "podId",
  "pointsBubbleWay",
  "polId",
  "quoteAttachPrice",
  "regionHeaderList",
  "deliveryRegionHeaderList",
  "regionType",
  "sailingTime",
  "specialRequirements",
  // "state",
  "volumeWeightRatio",
  "weightVolumeRatio",
  "warmPrompt",
  "deliveryType",
  "overseasWarehouseId",
  "isProductSurcharge",
  "selfDelivery",//是否支持自提(是否支持自提) 1: 可自提 2：不可自提 3：强制自提
  "isSupportMultiChannel",//是否多渠道
  // "channelCode",//非多渠道时的专线api对接渠道代码
  "goodsTypeList",//可走货物类型

  "compensationStandards",// 赔付标准
  "smartCarrierId",// 引用报价供应商Id
  "shippingDateInformation",// 船期信息 整柜直送时需要
  "carrierProductCode", // 专线渠道代码(物流产品代码)
  // 是否推送更新至收藏客户
  "pushOpen",
  // 推送更新说明（true时必填）
  "pushContent",
  "goodsMeasurementMethod",
  "whetherSupportedBargaining",
  "whetherSupportedCompensate",
  "shippingCompanyList",
  "whetherGuaranteedDelivery",
  "whetherSupportCompensation",
  "endDeliveryTypeIds",
  "closeWarehouseTime",
  "startShipmentTime",
  "supportedCompensateDesc",
  "supportCompensationDesc"
];

/**
 * 以起运城市为维度的 全包(头程) 分区价格信息列表的单个item数据结构
 */
export function baseDataCityListRegionHeaderItem(){
  return {
    _id: `${getLocalId()}`,
    label:"",
    // 城市列表 { cityName:"", id:"",},
    cityList:[],
    // 全包(头程) 分区价格信息列表 baseDataRegionHeaderItem()
    regionHeaderList:[],
    // 是否支持多产品分类报价 0>false 1>true
    isSupportMultiGoodsTypePrice:0,
  }
}
/**
 * 以起运城市为维度的 全包(头程) 分区价格信息列表的单个item 内cityList的单个cityItem
 */
export function baseDataCityRegionInnerCityItem(){
  return {
    // 城市代码
    // "cityCode": "",
    // 城市名称
    "cityName": "",
    // 城市英文名称
    // "cityNamee": "",
    // 城市id
    "id": undefined,
    // 该城市是否支持上门取件
    "pickUpFlag": false,
    // 是否平台共享仓
    // "platformShareWarehouseFlag": false,
    // 省份id
    // "provinceId": undefined,
    // 收货仓库id，可能为共享仓或供应商自营仓
    "receiveWarehouseId": undefined,
    // 收货仓库名称
    // "receiveWarehouseName": "",
    // 排序
    // "sort": undefined,
    // 送货到仓可选仓库列表
    // warehouseList:[],
    // 是否已初始化数据(根据城市id获取供应商对应收货仓库信息)
    // alreadyInit:false,
  }
}

/**
 * 基础数据：运费价格设置—— 运费分区价格信息列表 单个Item
 */
export function baseDataRegionHeaderItem(){
  return {
    _id: `${getLocalId()}`,
    // "agingFrom": "", // 整体时效最短时间
    // "agingTo": "", // 整体时效最长时间
    // "agingUnit": "", // 整体时效单位 1：工作日 2：自然日
    // "agingType": "", // 整体时效类型，1：开船后开始计算时效；2：入仓后开始计算时效
    // "agingIsShow": "", // 是否展示整体时效
    "chargeType": "", //计费方式: CBM:体积 KG:重量
    "cityList": [], //起运城市 [{cityName,id},]
    "currency": "", // 计费币种
    "dispatchId": "", // 关联派送区间id
    "containerId": "", //按车计费，卡车id
    // "extractionAgingFrom": "", //提取时效最短时间
    // "extractionAgingTo": "", // 提取时效最长时间
    // "extractionAgingUnit": "", // 提取时效单位 1：工作日 2：自然日
    // "extractionAgingType": "", // 提取时效类型，1：开船后开始计算时效；2：入仓后开始计算时效
    // "extractionAgingIsShow": "", // 是否展示提取时效
    "priceDetailList": [], // 价格明细列表 baseDataPriceDetailItem()
    "regionDetailList": [],// 分区类型明细列表 baseDataRegionDetailItem()
    "regionName": "",//分区名称
    "regionType": "",//分区类型 1：邮编 2：国家 3：城市 4：仓库编码 5:邮编分区
    // "remark": "",//备注
    "type": "",//1：全包(头程) 2:派送
    // "regionSelectValue": [], //选择的分区信息值（仅供本地js操作使用）
    // "isNeedInquiry":false,//是否支持单询
    // "colspan":1,//单询时当前行的合并列数量（仅供本地js展示数据表格样式使用）
    // "exemptionType":1,// 免派类型，1：不免派(默认)；2：免派
    // "channelCode":"",// 多渠道时的专线api对接渠道代码（多渠道时提交时需要填充到价格明细列表）
    "isSupportMultiGoodsTypePrice":0,//是否支持多产品分类报价 0>false 1>true
    "supportRenewal": false,//是否支持首续重
    "isOnlySupportRenewal": false,//首重续重 是否支持多分段报价
    "isCollectRenewalFee": false,//超出续重区间是否仍收取首重费
    "dismantlingCityId":"",//拆柜城市id
    "dismantlingCityName":"",//拆柜城市名称
  }
}

/**
 * 基础数据：运费价格设置—— 单个"运费分区价格信息"Item 价格明细列表item
 */
export function baseDataPriceDetailItem(){
  let local = baseDataCityRegionHeaderPriceTableItem();// 仅供本地table展示数据使用
  return Object.assign({
    _id: `${getLocalId()}`,
    "agingFrom": "", // 整体时效最短时间
    "agingTo": "", // 整体时效最长时间
    "agingUnit": "", // 整体时效单位 1：工作日 2：自然日
    "agingType": "", // 整体时效类型，1：开船后开始计算时效；2：入仓后开始计算时效
    "agingIsShow": "", // 是否展示整体时效

    "extractionAgingFrom": "", //提取时效最短时间
    "extractionAgingTo": "", // 提取时效最长时间
    "extractionAgingUnit": "", // 提取时效单位 1：工作日 2：自然日
    "extractionAgingType": "", // 提取时效类型，1：开船后开始计算时效；2：入仓后开始计算时效
    "extractionAgingIsShow": "", // 是否展示提取时效

    "goodsTypeList": [],// 货物类型 baseDataPriceDetailGoodsTypeItem(),
    "priceList": [],  // 价格明细列表 baseDataPriceDetailPriceItem(),
    "channelCode": "",  // 专线api对接渠道代码
    "isNeedInquiry":false,//是否支持单询
    "exemptionType":1,// 免派类型，1：不免派(默认)；2：免派
    "remark": "",//备注
    // 体积重比率
    "volumeWeightRatio": "",
    //重量体积比率
    "weightVolumeRatio": "",
  },local)
}
export function baseDataPriceDetailPriceItem(start, supportRenewal, type){
  return {
    "chargeSectionDetailId": "",// 分区区间id
    "price": start === 0 && !supportRenewal && type === 1 ? "0" : "",  // 单价
    "sectionStartNum": "", // 区间开始值
    "sectionEndNum": "", // 区间结束值

    // "chargeType": "", // 计费方式: CBM:体积 KG:重量
  }
}
export function baseDataPriceDetailGoodsTypeItem(){
  return {
    "goodsTypeName": "",// 货物类型名称
    "id": "",  // 货物类型id
  }
}
/**
 * 基础数据：运费价格设置—— 单个"运费分区价格信息"Item 分区类型明细列表item
 */
export function baseDataRegionDetailItem(){
  return {
    "namec": "", // 分区类型展示名称-仓库名或邮编名或国家名或城市名
    "warehouseId": "",//分区类型展示id-仓库id或邮编id或国家id或城市id
  }
}


/**
 * 处理 报价详情接口获取的数据 以供编辑使用
 */
export function disposeRequestDataToEdit(data= {}){
  if(typeof data !== 'object') return false;
  if(!data) return false;
  try {
    data = JSON.parse(JSON.stringify(data));
  }catch (e) {
    data = {}
  }
  data = mapObjectKeyName(data,{
    // effectiveStartTime:"effectivestarttime",
    // effectiveEndTime:"effectiveendtime",
    // cityId:"cityid",
    // transportnamec:"transport_type",
  });
  disposeGetRegionHeaderList(data.regionHeaderList);
  disposeGetRegionHeaderList(data.deliveryRegionHeaderList);
  return data;
}

function mapObjectKeyName(target = {}, prop = {},isDelete = true) {
  if (!target) return {};
  prop = Object.assign({}, prop); // {myName:'myname'} 将 target中的myname转为myName 并删除
  let keys = Object.keys(prop);
  keys.forEach(key=>{
    let keyOld = prop[key];
    target[key] = target[keyOld];
    if(isDelete) delete target[keyOld];
  });
  return target;
}

/**
 * 处理通过详情接口获取的 头程/派送 分区数据
 */
export function disposeGetRegionHeaderList(list=[],clearPrice= false){
  if(!isArray(list) || list.length<=0) return [];
  list.forEach(res=>{
    if(res.regionDetailList){
      res.regionSelectValue =  res.regionDetailList.map(item=>{
        item.chargeType = res.chargeType;
        if(clearPrice) item.price = "";
        return item.warehouseId;
      });
    }else{
      res.regionSelectValue = [];
    }
  });
  return list;
}

/**
 * 基础数据：增值服务（提交）
 */
export function baseDataQuoteAttachPrice(){
  return {
    "beginTime": "",// 开始时间
    "busType": "", // 物流产品业务类型
    "chargeDTO": [ // 超重费、大型包裹费
      {
        "chargeFrom": 0, // 起始值
        "chargeLimit": 0, // 超过多少拒收
        "chargeTo": 0,  // 结束值
        "code": "", // 费用代码
        "feeDescription": "", // 费用描述
        "feeitemid": 0, // 增值服务Id
        "name": "", // 费用名称
        "price": 0  // 价格
      }
    ],
    "countryId": 0, // 国家id
    "declarationDTO": [ // 一般贸易报关费
      {
        "baseNum": 0, // 一般贸易报关费单票免费品名数量
        "code": "", // 费用代码
        "feeDescription": "", // 费用描述
        "feeitemid": 0, // 增值服务Id
        "minimumCharge": 0, // 一般贸易报关费最低收费
        "name": "", // 费用名称
        "price": 0  // 价格
      }
    ],
    "detailDTO": [ // 一般增值服务
      {
        "code": "", // 增值服务code
        "feeDescription": "", // 费用描述
        "feeitemid": 0, // 增值服务Id
        "name": "", // 增值服务名
        "price": 0, // 价格
        "priceUnit": "" // 计费单位
      }
    ],
    "endTime": "", // 结束时间
    "id": 0, // 记录id
    "lightDTO": [ // 超轻费
      {
        "code": "", // 费用代码
        "feeDescription": "", // 费用描述
        "feeitemid": 0, // 增值服务Id
        "minimumLimit": 0,  // 单件小于限制KG，加收费用
        "name": "", // 费用名称
        "price": 0  // 价格
      }
    ],
    "quoteRankid": 0, // 客户等级id
    "remarks": "" // 备注
  }
}

/**
 * 基础数据：增值服务（本地编辑用）
 */
export function baseDataAddedServiceList(){
  return [
    {name:'海外换箱费',feeitemid:18998740400,code:'FB009',isPremium:2,useDefaultTemplate:true,propKey:'price',rulesKey:'require',priceUnitText:'RMB/箱',priceUnit:'',price:'',},
    {name:'海外代贴条码费',feeitemid:18998739900,code:'FB010',isPremium:2,useDefaultTemplate:true,propKey:'price',rulesKey:'require',priceUnitText:'RMB/张',priceUnit:'',price:'',},
    {name:'海外打托费',feeitemid:18998740500,code:'FB011',isPremium:2,useDefaultTemplate:true,propKey:'price',rulesKey:'require',priceUnitText:'RMB/托',priceUnit:'',price:'',},
    {name:'海外面单贴换费',feeitemid:18998740600,code:'FB012',isPremium:2,useDefaultTemplate:true,propKey:'price',rulesKey:'require',priceUnitText:'RMB/张',priceUnit:'',price:'',},
    {name:'海外仓储费',feeitemid:18998740800,code:'FB013',isPremium:2,useDefaultTemplate:true,propKey:'price',rulesKey:'require',priceUnitText:'RMB/CBM/天',priceUnit:'',price:'',},
    {name:'海外滞仓费',feeitemid:18998741100,code:'FB015',isPremium:2,useDefaultTemplate:true,propKey:'price',rulesKey:'require',priceUnitText:'RMB/CBM/天',priceUnit:'',price:'',},
    {name:'地址修正费',feeitemid:18998741200,code:'FB016',isPremium:2,useDefaultTemplate:true,propKey:'price',rulesKey:'require',priceUnitText:'RMB/票',priceUnit:'',price:'',},
    {name:'VAT服务费',feeitemid:18998741000,code:'FB014',isPremium:2,useDefaultTemplate:false,priceUnit:'',price:'',},
    {name:'超重费',feeitemid:18998741400,code:'FB017',isPremium:2,useDefaultTemplate:false,
      chargeFrom:'',//起始值
      chargeLimit:'',//超过多少拒收
      chargeTo:'',//结束值
      price:'',//价格
    },
    {name:'超轻费',feeitemid:18998741700,code:'FB018',isPremium:2,useDefaultTemplate:false,
      minimumLimit:'',//单件小于限制KG，加收费用
      price:'',//价格
    },
    {name:'一般贸易报关费',feeitemid:18998741800,code:'FB019',isPremium:2,useDefaultTemplate:false,
      baseNum:'',//一般贸易报关费单票免费品名数量
      minimumCharge:'',//一般贸易报关费最低收费
      price:'',//价格
    },
    {name:'偏远费',feeitemid:18998743100,code:'FB020',isPremium:2,useDefaultTemplate:false,priceUnit:'',price:'',},
    {name:'大型包裹费',feeitemid:18998744000,code:'FB021',isPremium:2,useDefaultTemplate:false,
      chargeFrom:'',//起始值
      chargeLimit:'',//超过多少拒收
      chargeTo:'',//结束值
      price:'',//价格
    },
    {name:'二次送仓费',feeitemid:18998744200,code:'FB022',isPremium:2,useDefaultTemplate:false,priceUnit:'',price:'',},
    // {name:'产品附加费',feeitemid:19009816500,code:'FB023',isPremium:2,useDefaultTemplate:false,priceUnit:'',price:'',},
  ];
}

export function testData(){
  return {}
  // return {
  //   "regionHeaderList": [{
  //     "regionName": "默认",
  //     "regionType": 0,
  //     "priceDetailList": [{
  //       "chargeSectionDetailId": 18988409500,
  //       "price": "123",
  //       "sectionStartNum": 0,
  //       "sectionEndNum": 100,
  //       "titleText": "0-100 CBM"
  //     }, {
  //       "chargeSectionDetailId": 18998522900,
  //       "price": "123",
  //       "sectionStartNum": 100,
  //       "sectionEndNum": 1000,
  //       "titleText": "100-1000 CBM"
  //     }, {
  //       "chargeSectionDetailId": 18998523000,
  //       "price": "213",
  //       "sectionStartNum": 1000,
  //       "sectionEndNum": 99999,
  //       "titleText": "1000-99999 CBM"
  //     }],
  //     "regionDetailList": [{"warehouseId": ""}],
  //     "agingFrom": "03",
  //     "agingTo": "04",
  //     "agingUnit": 1,
  //     "extractionAgingFrom": "01",
  //     "extractionAgingTo": "02",
  //     "extractionAgingUnit": 1,
  //     "remark": "21",
  //     "regionSelectValue": [0, 4]
  //   }, {
  //     "regionName": "发",
  //     "regionType": 0,
  //     "priceDetailList": [{
  //       "chargeSectionDetailId": 18988409500,
  //       "price": "213",
  //       "sectionStartNum": 0,
  //       "sectionEndNum": 100,
  //       "titleText": "0-100 CBM"
  //     }, {
  //       "chargeSectionDetailId": 18998522900,
  //       "price": "213",
  //       "sectionStartNum": 100,
  //       "sectionEndNum": 1000,
  //       "titleText": "100-1000 CBM"
  //     }, {
  //       "chargeSectionDetailId": 18998523000,
  //       "price": "2131",
  //       "sectionStartNum": 1000,
  //       "sectionEndNum": 99999,
  //       "titleText": "1000-99999 CBM"
  //     }],
  //     "regionDetailList": [{"warehouseId": ""}],
  //     "agingFrom": "03",
  //     "agingTo": "04",
  //     "agingUnit": 1,
  //     "extractionAgingFrom": "01",
  //     "extractionAgingTo": "02",
  //     "extractionAgingUnit": 1,
  //     "remark": "123",
  //     "regionSelectValue": [1]
  //   }],
  //   "id": "",
  //   "logisticsProductId": 18998761000,
  //   "cityId": 18957250100,
  //   "podId": "18957256400",
  //   "effectiveStartTime": "2021-05-12 00:00",
  //   "effectiveEndTime": "2021-05-28 00:00",
  //   "chargeSectionHeaderId": 18988409400,
  //   "agingFrom": 3,
  //   "pointsBubbleWay": 2,
  //   "volumeWeightRatio": 5000,
  //   "sailingTime": "2021-05-13 00:00:00+08",
  //   "orderInformation": "<p>4</p>",
  //   "specialRequirements": "4",
  //   "warmPrompt": "4",
  //   "packagingRequirements": "4",
  //   "label1": null,
  //   "label2": null,
  //   "label3": null,
  //   "isSupportPrivateAddress": false,
  //   "scale": -1,
  //   "cityList": [{"cityname": "深圳市", "cityid": 18957250100}],
  //   "pieceWeightBiggestNotLimit": false,
  //   "tableHeadList": [{
  //     "chargeSectionDetailId": 18988409500,
  //     "start": 0,
  //     "end": 100
  //   }, {"chargeSectionDetailId": 18998522900, "start": 100, "end": 1000}, {
  //     "chargeSectionDetailId": 18998523000,
  //     "start": 1000,
  //     "end": 99999
  //   }],
  //   "remark": "asong测试中，勿删除",
  //   "polnamec": '测试',
  //   "agingUnit": 1,
  //   "transportNamec": "空运",
  //   "isNeedVat": false,
  //   "orderWeightMinimum": 4,
  //   "podnamec": "阿拉伯联合酋长国",
  //   "chargeCoefficient": null,
  //   "minimumCbm": null,
  //   "isSupportGeneralTrade": false,
  //   "name": "testAsong产品",
  //   "goodsTypeNamec": "普货",
  //   "polId": -1,
  //   "pieceWeightMinimumNotLimit": false,
  //   "regionType": '',
  //   "transport_type": "KY",
  //   "extractionAgingTo": 4,
  //   "pieceWeightBiggest": 4,
  //   "chargeType": "CBM",
  //   "pieceWeightMinimum": 4,
  //   "containsTheTariffs": false,
  //   "code": "rh",
  //   "orderWeightMinimumNotLimit": false,
  //   "agingTo": 4,
  //   "extractionAgingUnit": 1,
  //   "minimumWeight": null,
  //   "extractionAgingFrom": 3
  // }
}

/**
 * 用来展示的报价table 单个item
 * @returns {{dismantlingCityName: string, regionName: string, dismantlingCityId: string, agingType: string, cityNameText: string, extractionAgingUnit: string, agingTo: string, agingFrom: string, _idRegion: string, extractionAgingFrom: string, extractionAgingIsShow: string, agingIsShow: string, _idCityRegion: string, extractionAgingType: string, regionInfoText: string, extractionAgingTo: string, agingUnit: string}}
 */
export function baseDataCityRegionHeaderPriceTableItem(){
  let data = {
    _idCityRegion:"",//城市区间维度本地id
    // cityList:[],//起运城市列表
    cityNameText:"",//城市名称拼接文本
    _idRegion:"",//单个区间维度本地id
    regionName:"",//分区名称
    regionInfoText:"",//分区信息拼接文本

    "extractionAgingFrom": "", //提取时效最短时间
    "extractionAgingTo": "", // 提取时效最长时间
    "extractionAgingUnit": "", // 提取时效单位 1：工作日 2：自然日
    "extractionAgingType": "", // 提取时效类型，1：开船后开始计算时效；2：入仓后开始计算时效
    "extractionAgingIsShow": "", // 是否展示提取时效

    "agingFrom": "", // 整体时效最短时间
    "agingTo": "", // 整体时效最长时间
    "agingUnit": "", // 整体时效单位 1：工作日 2：自然日
    "agingType": "", // 整体时效类型，1：开船后开始计算时效；2：入仓后开始计算时效
    "agingIsShow": "", // 是否展示整体时效

    "dismantlingCityId":"",//拆柜城市id
    "dismantlingCityName":"",//拆柜城市名称
  }
  // Object.assign(baseDataPriceDetailItem(), data);
  return data;
}

/**
 * 解析 城市分区维度数据（全包/头程(带城市）） 得到用来展示的table数据
 * @param cityRegionList
 * @returns {*[]}
 */
export function parseCityRegionHeaderPriceTable(cityRegionList = []){
  let newList = [];
  cityRegionList.forEach((cityRegionItem,cityRegionIndex)=>{
    let arr = createRegionHeaderPriceTable(cityRegionItem.regionHeaderList,cityRegionItem);
    return newList.push(...arr);

    // let cityList = cityRegionItem.cityList;
    // let cityNameText = cityList.map(item=>item.cityName).join(",");
    // cityRegionItem.regionHeaderList.forEach((regionItem,regionIndex)=>{
    //   // regionItem.cityList = cityList;
    //   // regionItem.cityNameText = cityNameText;
    //   // newList.push(regionItem);
    //   let regionDetailList = regionItem.regionDetailList||[];
    //   let regionInfoText = joinRegionInfoText(regionDetailList);
    //   regionItem.priceDetailList.forEach((item,index)=>{
    //     let data = Object.assign(item,{
    //       _idCityRegion:cityRegionItem._id,
    //       cityNameText,
    //       // cityList,
    //       _idRegion:regionItem._id,
    //       regionName:regionItem.regionName,
    //       regionInfoText,
    //
    //       "extractionAgingFrom": regionItem.extractionAgingFrom, //提取时效最短时间
    //       "extractionAgingTo": regionItem.extractionAgingTo, // 提取时效最长时间
    //       "extractionAgingUnit": regionItem.extractionAgingUnit, // 提取时效单位 1：工作日 2：自然日
    //       "extractionAgingType": regionItem.extractionAgingType||1, // 提取时效类型，1：开船后开始计算时效；2：入仓后开始计算时效
    //       "extractionAgingIsShow": typeof regionItem.extractionAgingIsShow === "boolean" ? regionItem.extractionAgingIsShow : true, // 是否展示提取时效
    //       "agingFrom": regionItem.agingFrom, // 整体时效最短时间
    //       "agingTo": regionItem.agingTo, // 整体时效最长时间
    //       "agingUnit": regionItem.agingUnit, // 整体时效单位 1：工作日 2：自然日
    //       "agingType": regionItem.agingType||1, // 整体时效类型，1：开船后开始计算时效；2：入仓后开始计算时效
    //       "agingIsShow": typeof regionItem.agingIsShow === "boolean" ? regionItem.agingIsShow : true, // 是否展示整体时效
    //
    //     })
    //     newList.push(data);
    //   });
    // })
  })
  return newList;
}

/**
 * 解析 区间维度数据[regionItem] 得到用来展示的table数据
 * @param regionList
 * @param cityRegionItem
 * @param options
 * @returns {*[]}
 */
export function createRegionHeaderPriceTable(regionList = [],cityRegionItem={},options={}){
  let newList = [];
  let cityList = cityRegionItem.cityList||[];
  let cityNameText = cityList.map(item=>item.cityName).join(",");
  regionList.forEach((regionItem,regionIndex)=>{
    let regionDetailList = regionItem.regionDetailList||[];
    let regionInfoText = joinRegionInfoText(regionDetailList);
    regionItem.priceDetailList.forEach((item,index)=>{
      let data = Object.assign(item,{
        _idCityRegion:cityRegionItem._id||"",
        cityNameText,
        // cityList,
        _idRegion:regionItem._id,
        regionName:regionItem.regionName,
        regionInfoText,

        // "extractionAgingFrom": regionItem.extractionAgingFrom, //提取时效最短时间
        // "extractionAgingTo": regionItem.extractionAgingTo, // 提取时效最长时间
        // "extractionAgingUnit": regionItem.extractionAgingUnit, // 提取时效单位 1：工作日 2：自然日
        // "extractionAgingType": regionItem.extractionAgingType||1, // 提取时效类型，1：开船后开始计算时效；2：入仓后开始计算时效
        // "extractionAgingIsShow": typeof regionItem.extractionAgingIsShow === "boolean" ? regionItem.extractionAgingIsShow : true, // 是否展示提取时效
        // "agingFrom": regionItem.agingFrom, // 整体时效最短时间
        // "agingTo": regionItem.agingTo, // 整体时效最长时间
        // "agingUnit": regionItem.agingUnit, // 整体时效单位 1：工作日 2：自然日
        // "agingType": regionItem.agingType||1, // 整体时效类型，1：开船后开始计算时效；2：入仓后开始计算时效
        // "agingIsShow": typeof regionItem.agingIsShow === "boolean" ? regionItem.agingIsShow : true, // 是否展示整体时效

        "dismantlingCityId": regionItem.dismantlingCityId||"",//拆柜城市id
        "dismantlingCityName": regionItem.dismantlingCityName||"",//拆柜城市名称
      })
      newList.push(data);
    });
  })

  return newList;
}
function joinRegionInfoText(list = []){
  let regionInfoText = "";
  let joinMaxNumber = 5;
  if(list.length>=joinMaxNumber){
    list = list.slice(0,joinMaxNumber);
    regionInfoText = list.map(item=>item.namec).join(",")
    regionInfoText += "...";
  }else{
    regionInfoText = list.map(item=>item.namec).join(",");
  }
  return regionInfoText;
}



// WEBPACK FOOTER //
// ./src/components/QuotationManagement/components-productQuotation/productQuotation.js